var map = {
	"./car.png": "f9bd",
	"./collect.png": "cbba",
	"./collect1.png": "a1a7",
	"./demand.png": "2f05",
	"./demand1.png": "da66",
	"./discounts.png": "b5e8",
	"./discounts1.png": "8c76",
	"./enterprise.png": "8dfb",
	"./enterprise1.png": "8364",
	"./exchange.png": "9c32",
	"./exchange1.png": "f7ee",
	"./id.png": "7f16",
	"./id1.png": "5e1a",
	"./invoice.png": "9ae2",
	"./invoice1.png": "c488",
	"./ld.png": "50ff",
	"./news.png": "d720",
	"./news1.png": "6d58",
	"./order.png": "182a",
	"./order1.png": "e6a5",
	"./portrait.png": "6670",
	"./site.png": "b499",
	"./site1.png": "09d6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f7e8";